import { CustomTimeZoneId } from 'owa-datetime-store';
import { DisplayDate, owaDate } from 'owa-datetime';

/**
 * Converts a DisplayDate into an OwaDate, assuming the
 * display date represents a local time in the given time zone.
 *
 * NOTE: DisplayDate is being deprecated because it cannot
 * represent certain hours in the day daylight-savings ends
 * in the time zone of the user's MACHINE. Use OwaDate instead.
 * For the same reason, don't use date-fns; use functions from owaDate.
 */
export default (date: DisplayDate, timeZone: string = CustomTimeZoneId) =>
    date
        ? owaDate(
              timeZone,
              date.getFullYear(),
              date.getMonth(),
              date.getDate(),
              date.getHours(),
              date.getMinutes(),
              date.getSeconds(),
              date.getMilliseconds()
          )
        : undefined;
